var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgPlusCircle = function SvgPlusCircle(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 20.6c-4.742 0-8.6-3.857-8.6-8.6S7.258 3.4 12 3.4s8.6 3.857 8.6 8.6-3.858 8.6-8.6 8.6m0-16c-4.08 0-7.4 3.32-7.4 7.4s3.32 7.4 7.4 7.4c4.081 0 7.4-3.32 7.4-7.4S16.081 4.6 12 4.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.6 16.5h-1.2v-3.9H7.5v-1.2h3.9V7.5h1.2v3.9h3.9v1.2h-3.9z"
  })));
};
export { SvgPlusCircle as ReactComponent };
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none' viewBox='0 0 24 24'%3e%3cpath fill='currentColor' d='M12 20.6c-4.742 0-8.6-3.857-8.6-8.6S7.258 3.4 12 3.4s8.6 3.857 8.6 8.6-3.858 8.6-8.6 8.6m0-16c-4.08 0-7.4 3.32-7.4 7.4s3.32 7.4 7.4 7.4c4.081 0 7.4-3.32 7.4-7.4S16.081 4.6 12 4.6'/%3e%3cpath fill='currentColor' d='M12.6 16.5h-1.2v-3.9H7.5v-1.2h3.9V7.5h1.2v3.9h3.9v1.2h-3.9z'/%3e%3c/svg%3e";